import { render } from "./AdminPasswordConfig.vue?vue&type=template&id=e965b8be"
import script from "./AdminPasswordConfig.vue?vue&type=script&lang=js"
export * from "./AdminPasswordConfig.vue?vue&type=script&lang=js"

import "./AdminPasswordConfig.vue?vue&type=style&index=0&id=e965b8be&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__